import { z } from 'zod';

/**
 * Zod schemas for frontend form validation.
 * Mirrors backend Zod schemas (TODO: share via package when monorepo is ready).
 */

export const loginSchema = z.object({
  email: z.email(),
  password: z.string().min(8),
});

export const customerDetailsSchema = z.object({
  name: z.string().min(1).max(120),
  email: z.email(),
  phone: z.string().min(5).max(30),
  notes: z.string().max(500).optional(),
});

export const serviceSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  durationMinutes: z.coerce.number().int().min(5).max(480),
  price: z.coerce.number().nonnegative().optional(),
  currency: z.string().length(3).optional(),
  active: z.boolean().default(true),
});

export const staffSchema = z.object({
  name: z.string().min(1).max(120),
  email: z.union([z.email(), z.literal('')]).optional().transform(v => (v === '' ? undefined : v)),
  role: z.enum(['center_admin', 'staff']).default('staff'),
  active: z.boolean().default(true),
});

export const centerSchema = z.object({
  name: z.string().min(1).max(120),
  slug: z.string().min(1).max(60).regex(/^[a-z0-9-]+$/),
  timezone: z.string().min(1),
  allowedOrigins: z.string().min(1, 'Introduce al menos una URL de origen permitido'),
  adminEmail: z.email('Email inválido').optional(),
});

export const rescheduleSchema = z.object({
  newStartTime: z.iso.datetime({ offset: true }),
  staffId: z.string().optional(),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
export type CustomerDetailsFormValues = z.infer<typeof customerDetailsSchema>;
export type ServiceFormValues = z.infer<typeof serviceSchema>;
export type StaffFormValues = z.infer<typeof staffSchema>;
export type CenterFormValues = z.infer<typeof centerSchema>;
export type RescheduleFormValues = z.infer<typeof rescheduleSchema>;
